import Vue from "vue";
import VueRouter from "vue-router";
import isOldBrowser from "@/common/imports/isOldBrowser";

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: "/login",
            component: () => import("./components/login-page")
        },
        {
            path: "/action/:actionid",
            props: true,
            component: () => import('./components/action-page')
        },
        {
            path: "/maintenance",
            component: () => import("./components/maintenance-page")
        },
        {
            path: "/invite",
            component: () => import("./components/invite-page")
        },
        {
            path: "/forgotten-password",
            redirect: "/forgotten-password/complete"
        },
        {
            path: "/forgotten-password/complete",
            component: () => import("./components/forgotten-password-complete-page"),
        },
        {
            path: "/forgotten-password/request/:email?",
            component: () => import("./components/forgotten-password-request-page"),
            props: true
        },
        {
            path: "/compatibility",
            component: () => import("./components/compatibility-page")
        },
        {
            path: "*",
            redirect: "/login"
        }
    ]
});

router.beforeEach((to, from, next) => {
    (isOldBrowser() && to.path !== "/compatibility")
        ? next("/compatibility")
        : next()
});

export default router;
